import { render, staticRenderFns } from "./Advertising2Slot.vue?vue&type=template&id=9944c2f2&scoped=true"
import script from "./Advertising2Slot.vue?vue&type=script&lang=js"
export * from "./Advertising2Slot.vue?vue&type=script&lang=js"
import style0 from "./Advertising2Slot.vue?vue&type=style&index=0&id=9944c2f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9944c2f2",
  null
  
)

export default component.exports